import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { MerchantBulkRepository } from '@app/domain/ports/tpv/merchant-bulk.repository';
import { TpvBulkMerchantsResult } from '@app/domain/models/tpv/merchant-bulk.model';
import { TpvReportFile } from '@app/domain/models/tpv/tpv-report.model';

/** Mock del alta masiva de comercios para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class MerchantBulkMockDataSource extends MerchantBulkRepository {
  override createBulk(
    merchants: unknown[],
    _idempotencyKey?: string,
  ): Observable<TpvBulkMerchantsResult> {
    return of<TpvBulkMerchantsResult>({
      message: 'Alta masiva de comercios procesada',
      data: { created: merchants.length, errors: [] },
    }).pipe(delay(600));
  }

  override getTemplate(): Observable<TpvReportFile> {
    return of<TpvReportFile>({
      fileName: 'layout-comercios.xlsx',
      // Base64 vacío de prueba; en mocks no se descarga un archivo real.
      fileBase64: '',
      fileSize: 0,
    }).pipe(delay(400));
  }
}
